export default class Map {
	constructor(el) {
		this.el = el;

		this.elms = {
			paths: this.el.querySelectorAll("[data-schoolmap-target]"),
			links: this.el.querySelectorAll("[data-schoolmap-link]"),
		};
 
    this.init();
	}

	init() {
		// --- SVG → Liste
		this.elms.paths.forEach((path) => {
			const key = path.dataset.schoolmapTarget;

			// clic sur la zone SVG
			path.addEventListener("click", () => {
        const link = this.getLinkByKey(key); 
				if (link) {
					window.clearCookies();
					window.location.href = link.href;
				}
			});

			// hover SVG
			path.addEventListener("mouseenter", () => {
				path.classList.add("is-hovered");
				this.getLinkByKey(key)?.classList.add("is-hovered");
			});

			path.addEventListener("mouseleave", () => {
				path.classList.remove("is-hovered");
				this.getLinkByKey(key)?.classList.remove("is-hovered");
			});
		});

		// --- Liste → SVG
		this.elms.links.forEach((link) => {
			const key = link.dataset.schoolmapLink;

			link.addEventListener("click", () => { 
				window.clearCookies();  
			});

			link.addEventListener("mouseenter", () => {
				link.classList.add("is-hovered");
				this.getPathByKey(key)?.classList.add("is-hovered");
			});

			link.addEventListener("mouseleave", () => {
				link.classList.remove("is-hovered");
				this.getPathByKey(key)?.classList.remove("is-hovered");
			});
		}); 
	}

	getLinkByKey(key) {
		return document.querySelector(`[data-schoolmap-link="${key}"]`);
	}

	getPathByKey(key) {
		return document.querySelector(`[data-schoolmap-target="${key}"]`);
	}
}
